<template>
  <div class="moderator-candidate-resumes">

    <ErrorView v-if="error"
               :code="error.code"
               :title="$tVacancy(error.message)"/>

    <template v-else>
      <AMCandidatesResumesPageActions :queryFilterKeys="queryFilterKeys"
                                      :querySearchTypes="querySearchTypes"
                                      class="moderator-candidate-resumes__actions"/>

      <div class="moderator-candidate-resumes__table">
        <AMCandidatesResumesPageResumeItemRowHead/>

        <div class="moderator-candidate-resumes__table-content">
          <div v-if="!pending && (!resumes || !resumes.length)"
               style="display: flex; align-items: center; justify-content: center; padding-top: 2rem; opacity: 0.7">
            {{ $tModeratorCandidates('Resume not found') }}
          </div>

          <template v-for="(resume, index) in resumes">
            <AMCandidatesResumesPageResumeItemRow :key="resume.id"
                                                  :resume="resume"/>

            <CollapseTransition :key="'info' + resume.id">
              <div v-if="isOpen(resume.id)">
                <AMCandidatesResumesPageResumeInfo :id="resume.id"
                                                   @update="onUpdate(index, $event)"/>

                <AMCandidatesResumesPageResumePassports/>
              </div>
            </CollapseTransition>
          </template>

          <BasePreloader v-if="pending"/>
        </div>
      </div>

      <div v-if="pagesQuantity > 1"
           class="moderator-candidate-resumes__footer">
        <Pagination :quantity="pagesQuantity"
                    :withGoTo="false"
                    class="moderator-candidate-resumes__pagination"/>
      </div>
    </template>
  </div>
</template>

<script>
  import {union} from 'lodash'
  import {CollapseTransition} from 'vue2-transitions'
  import ErrorView from '@/components/ErrorView'
  import Pagination from '@/components/Pagination'

  import AMCandidatesResumesPageActions
    from '@/components/moderatorCandidatesResumes/AMCandidatesResumesPageActions'
  import AMCandidatesResumesPageResumeItemRow
    from '@/components/moderatorCandidatesResumes/AMCandidatesResumesPageResumeItemRow'
  import AMCandidatesResumesPageResumeItemRowHead
    from '@/components/moderatorCandidatesResumes/AMCandidatesResumesPageResumeItemRowHead'
  import AMCandidatesResumesPageResumeInfo
    from '@/components/moderatorCandidatesResumes/AMCandidatesResumesPageResumeInfo'
  import AMCandidatesResumesPageResumePassports
    from '@/components/moderatorCandidatesResumes/AMCandidatesResumesPageResumePassports'

  import {http} from '@/axios'
  import handleError from '@/helpers/handleError'

  const queryFilterKeys = [
    'passport_uploaded',
    'questionnaire_status_end',
    'have_interaction',
    'nothave_interaction',
    'have_sent',
    'nothave_sent',
    'checked_passport',
    'notchecked_passport',
    'questionnaire_status_on_reload',
  ]


  const querySearchTypes = [{
    text: 'search_type_customer',
    value: 'customer',
  }, {
    text: 'search_type_id',
    value: 'id',
    // }, {
    //   text: 'search_type_created_at',
    //   value: 'created_at',
  }]

  export default {
    name: 'AccountModeratorMCandidatesResumesPage',
    components: {
      ErrorView,
      Pagination,
      CollapseTransition,
      AMCandidatesResumesPageActions,
      AMCandidatesResumesPageResumeItemRow,
      AMCandidatesResumesPageResumeItemRowHead,
      AMCandidatesResumesPageResumeInfo,
      AMCandidatesResumesPageResumePassports,
    },
    data() {
      return {
        openId: null,
        resumes: null,
        pending: true,
        error: null,
        pagesQuantity: null,
        queryFilterKeys,
        querySearchTypes,
      }
    },
    computed: {
      currentResumeId() {
        return parseFloat(this.$route.query['current-resume'] || '')
      }
    },
    methods: {
      isOpen(id) {
        return id === this.currentResumeId
      },
      onUpdate(index, resume) {
        this.$set(this.resumes, index, resume)
      },
      load() {
        this.pending = true
        this.error = null

        const query = this.$route.query
        const filters = []

        for (const key of queryFilterKeys) {
          const value = query[key]
          if (value && value.toString() === 'true') {
            filters.push(key)
          }
        }

        const q_by = query.search
          ? query['search-type'] || querySearchTypes[0].value
          : null

        const params = {
          page: query.page,
          q_by,
          q: query.search,
          sort: query.sort,
          filters
        }


        http.get('/api/backoffice/resumes', {
          params
        })
          .then(({data}) => {
            data = data.resumes
            this.resumes = data.data
            this.pagesQuantity = data.last_page || null
          })
          .catch(e => {
            this.resumes = null
            this.pagesQuantity = null

            this.error = {
              code: e.response && e.response.status,
              message: handleError(e)
            }
          })
          .finally(() => {
            this.pending = false
          })
      }
    },
    created() {
      this.load()
    },
    watch: {
      '$route.query'(to, from) {
        const toKeys = Object.keys(to)
        const fromKeys = Object.keys(from)


        const keys = union(toKeys, fromKeys)
        const dif = []

        keys.forEach(key => {
          if (to[key] !== from[key]) {
            dif.push(key)
          }
        })

        if (dif.length === 1 && dif.includes('current-resume')) return

        this.load()
      }
    }
  }
</script>

<style lang="less">

</style>
